/**
 * Copy text to the clipboard, preferring the async Clipboard API and falling back
 * to a hidden-textarea + execCommand('copy') for non-secure contexts / older WebViews
 * (the native app), where navigator.clipboard can be unavailable or throw. Returns
 * whether the copy succeeded so the caller can toast the outcome.
 */
export default async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the legacy path
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
